<template>
  <div>
    <answer-render ref="answer" :config="config">
      <div class="area-wrapper" slot="body">
        <FormItem prop="value" :rules="rules">
          <div class="form-inner">
            <!-- pc端 -->
            <div v-if="windowType === 'pc'" class="area-box">
              <el-select
                v-for="(levelItem, levelIndex) in maxLevel"
                :key="levelIndex"
                v-model="selData['anQuItemId' + levelIndex]"
                :placeholder="cvtLang('tipsPleaseSelect', surveyInfoLang.tipsPleaseSelect) + (levelIndex === 0 ? '省份' : (levelIndex === 1 ? '城市' : '区县'))"
                @change="genLevelData(levelIndex)"
              >
                <el-option
                  v-for="item in levelDataMap[levelIndex]"
                  :key="item.dictValue"
                  :disabled="item.disabled"
                  :label="item.dictLabel"
                  :value="item.dictValue">
                </el-option>
              </el-select>
            </div>
            <!-- 手机端 -->
            <div v-if="windowType === 'mobile'" class="area-box">
              <div class="select-box" @click="showAddress">
                <span v-if="!fieldValue" class="tips">{{tipsMapTitle}}</span>
                <span v-else>{{ fieldValue }}</span>
                <van-icon name="arrow-down" />
              </div>
              <van-popup v-model="show" get-container="body" safe-area-inset-bottom round position="bottom">
                <van-cascader
                  v-model="cascaderValue"
                  :title="tipsMapTitle"
                  :placeholder="cvtLang('tipsPleaseSelect', surveyInfoLang.tipsPleaseSelect)"
                  :options="formatDataList"
                  :field-names="fieldNames"
                  active-color="#05C6AF"
                  @close="show = false"
                  @change="onChange"
                  @finish="onFinish"
                />
                <div class="action-btn">
                  <van-button :disabled="disabledSelect" color="#4CBAA2" type="primary" @click="confirmSelect">{{cvtLang('btnConfirm', surveyInfoLang.btnConfirm)}}</van-button>
                </div>
              </van-popup>
            </div>
            <div class="dtl" v-if="config.answerConfig.paramInt01 === '4'">
              <Input
                class="textarea"
                v-model="config.otherAnswer"
                type="textarea"
                :placeholder="cvtLang('tipsDetailAdress', config.tipsDetailAdress)"
                :autosize="{minRows: 3,maxRows: 5}"
                :maxlength="200"
              />
            </div>
          </div>
        </FormItem>
      </div>
    </answer-render>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import answerValidate from './answerValidate'
import cloneDeep from 'loadsh/cloneDeep'
export default {
  name: 'SelectBoxAnswer',
  props: ['config'],
  data () {
    return {
      listData: [],
      loading: true,
      show: false,
      cascaderValue: '',
      fieldValue: '',
      disabledSelect: true,
      tipsMap: {
        '1': 'tipsProvince',
        '2': 'tipsProvinceCity',
        '3': 'tipsProvinceCityArea',
        '4': 'tipsProvinceCityAreaDetail',
      },
      fieldNames: {
        text: 'dictLabel',
        value: 'dictValue',
        children: 'children',
      },
      moileDataList: [], // 用于手机端地址选择控件
      formatDataList: [],
      level: 0,
      stashSelectedOptions: [],

      maxLevel: 0,
      levelDataMap: {}, // 存放数据
      selData: {},

      inited: false,
      rules: [
        {
          validator: (rule, value, callback) => {
            if (this.loading) {
              return callback()
            }
            const errors = answerValidate.validate.bind(this.config)(this).errors
            if (errors.length) {
              return callback(errors)
            }
            return callback()
          }
        }
      ]
    }
  },
  components: {},
  watch: {
    'config.invalidConfig': {
      handler(newVal) {
        if (newVal) {
          // reset value
          this.config.value = ''
          this.config.textValue = ''
          this.fieldValue = ''
          for(let key in this.selData) {
            this.selData[key] = ''
          }
          this.setDisabeldOption()
        } else {
          for(let key in this.levelDataMap) {
            if (this.levelDataMap[key].length) {
              this.levelDataMap[key].forEach(item => {item.disabled = false})
            }
          }
          this.formatDataList = cloneDeep(this.moileDataList)
        }
      }
    }
  },
  computed: {
    ...mapState({
      windowType: ({Question}) => Question.windowType,
      langMap: ({Question}) => Question.langMap,
      lang: ({Question}) => Question.lang,
      surveyInfoLang: ({Question}) => Question.surveyInfoLang, // 基础语言配置（提示文字、按钮、题型）
    }),
    tipsMapTitle() {
      return this.cvtLang(this.tipsMap[this.config.answerConfig.paramInt01], this.config[this.tipsMap[this.config.answerConfig.paramInt01]])
    }
  },
  methods: {
    // TODO 引用/继承
    isOrigin () {
      return this.lang === 'origin'
    },
    // TODO 引用/继承
    cvtLang: function (id, title) {
      if (this.isOrigin()) {
        return title
      }
      const {lang, langMap} = this
      const key = `${id}_${lang}`
      const value = langMap[key]
      if (!value) {
        this.$set(langMap, key, '')
      }
      return langMap[key]
    },
    onChange(opt) {
      const {invalidConfig} = this.config
      let { answerConfig: { paramInt01 } } = this.config
      if (paramInt01 === '4' && opt.tabIndex === Number(paramInt01) - 2) {
        // 带详细地址
        return
      } else if (paramInt01 !== '4' && opt.tabIndex === Number(paramInt01) - 1) {
        // 不带详细地址
        return
      }
      let childrenItem = this.getLevelData(this.getCodeByValue(opt.value))
      if (invalidConfig) {
        invalidConfig.optionIds.forEach(id => {
          const disabledItem = childrenItem.find(item => item.code === id)
          if (disabledItem) {
            this.$set(disabledItem, 'disabled', true)
          }
        })
      } else {
        childrenItem.forEach(item => {
          item.disabled = false
        })
      }
      opt.selectedOptions[opt.tabIndex].children = childrenItem.filter(item => {return !item.disabled})
      this.disabledSelect = true
    },
    onFinish({ selectedOptions }) {
      this.disabledSelect = false
      this.stashSelectedOptions = selectedOptions
    },
    confirmSelect() {
      sessionStorage.setItem('allOrderByIdStash', this.config.allOrderById)
      this.show = false
      this.fieldValue = this.stashSelectedOptions.map((option) => option.dictLabel).join(',')

      this.config.value = this.stashSelectedOptions.map(item => (item.dictValue)).join(',')
      this.config.textValue = this.stashSelectedOptions.map(item => (item.dictLabel)).join(',')
    },
    getName (id) {
      if (this.listData.find(item => item.dictValue === id)) {
        return this.listData.find(item => item.dictValue === id).dictLabel
      } else {
        return ''
      }
    },
    // 展示地址
    showAddress() {
      this.show = true
    },
    // 手机端，设置默认选中
    setValueSelect (list) {
      let { answerConfig: { paramInt01 } } = this.config
      let values = this.config.value.split(',')
      
      if (values.length) {
        let currItem = list.find(item => (item.dictValue === values[this.level]))
        if ((paramInt01 === '4' && this.level < Number(paramInt01) - 2) || paramInt01 !== '4' && this.level < Number(paramInt01) - 1) {
          currItem.children = []
        } else {
          this.cascaderValue = values[this.level]
        }
        if (currItem.children) {
          currItem.children = this.getLevelData(this.getCodeByValue(values[this.level]))
          this.cascaderValue = values[this.level]
          this.level = this.level + 1
          this.cascaderValue = values[this.level]
          this.setValueSelect(currItem.children)
        }
      }
    },

    getLevelData (pId) {
      return this.listData.filter(item => item.parentCode === pId)
    },
    getLevel1Data () {
      return this.listData.filter(item => item.parentCode === '0')
    },
    getCodeByValue(id) {
      return this.listData.find(item => (item.dictValue === id)).code
    },
    genLevelData (level) {
      sessionStorage.setItem('allOrderByIdStash', this.config.allOrderById)

      const pId = this.selData['anQuItemId' + level]
      level += 1
      for (let i = level; i < this.maxLevel; i += 1) {
        this.selData['anQuItemId' + i] = ''
        const levelData = this.levelDataMap[i]
        levelData.splice(0, levelData.length)
      }
      if (level < this.maxLevel) {
        const levelData = this.levelDataMap[level]
        levelData.splice(0, levelData.length, ...this.getLevelData(this.getCodeByValue(pId)))
      }
      this.setValues()
      // 禁用选项
      this.setDisabeldOption()
    },
    setDisabeldOption() {
      const {invalidConfig} = this.config
      if (!invalidConfig) {return}
      for(let key in this.levelDataMap) {
        invalidConfig.optionIds.forEach(id => {
          if (this.levelDataMap[key] && this.levelDataMap[key].length) {
            const disabledItem = this.levelDataMap[key].find(item => item.code === id)
            if (disabledItem) {
              this.$set(disabledItem, 'disabled', true)
            }
          }
        })
      }
      if (this.windowType === 'mobile') {
        this.formatDataList = cloneDeep(this.filterList(this.moileDataList))
      }
    },
    filterList(res) {
      return res.filter(item => {
        return !item.disabled
      }).map(item => {
        item = Object.assign({}, item)
        if (item.children) {
          item.children = this.filterList(item.children)
        }
        return item
      })
    },
    setValues() {
      let values = []
      let textValues = []

      for (let i = 0; i < this.maxLevel; i += 1) {
        if(this.selData['anQuItemId' + i]) {
          values.push(this.selData['anQuItemId' + i])
          const findObj = this.listData.find(item => item.dictValue === this.selData['anQuItemId' + i])
          if (findObj) {
            textValues.push(findObj.dictLabel)
          }
        }
      }
      this.config.value = values.join(',')
      this.config.textValue = textValues.join(',')
    },

    // 格式化数据
    formatData() {
      let { answerConfig: { paramInt01 }, value } = this.config
      paramInt01 = paramInt01 || '2'
      if (paramInt01 > 3) {
        paramInt01 = 3
      }
      for (let i = 0; i < paramInt01; i += 1) {
        this.$set(this.levelDataMap, i, [])
        this.$set(this.selData, 'anQuItemId' + i, '')
      }
      this.levelDataMap[0].push(...this.getLevel1Data())

      if (this.windowType === 'mobile') {
        this.moileDataList = this.levelDataMap[0]
        this.formatDataList = cloneDeep(this.moileDataList)
        
        if (this.config.textValue) {
          // 如果有值则默认选中
          this.fieldValue = this.config.textValue
          this.setValueSelect(this.moileDataList)
        }
      }

      // 禁用选项
      this.setDisabeldOption()

      // 如有值，默认选中
      if (this.config.value) {
        this.config.value.split(',').forEach((item, index) => {
          this.selData['anQuItemId' + index] = item
          this.genLevelData(index)
        })
      }
      this.$nextTick(_ => {
        this.inited = true
        setTimeout(_ => {
          this.loading = false
        }, 200)
      })

    },

    // 初始化省市区数据
    initLevelData () {
      let { answerConfig: { paramInt01 }, value } = this.config
      paramInt01 = paramInt01 || '2'
      if (paramInt01 > 3) {
        paramInt01 = 3
      }
      this.maxLevel = Number(paramInt01)

      if (window._env_ === 'android') {
        // android app下
        const storageData = H5Expand.getSysLocation()
        this.listData = storageData.map(item => ({
            ...item,
            children: undefined // 将children加为响应式对象，供级联组件使用
          })) || []

        this.formatData()
      } else {
        axios.get('/prod-api/system/dict/data/typedata/sys_location').then(res => {
          this.listData = res.data.data && res.data.data.map(item => ({
            ...item,
            children: undefined // 将children加为响应式对象，供级联组件使用
          })) || []

          this.formatData()
        })
      }
    }
  },
  created () {
  },
  mounted () {
    this.initLevelData()
  }
}
</script>
<style lang="scss" scoped>
  .dtl {
    margin-top: 18px;
  }
  .area-wrapper {
    min-height: 140px;
    .form-inner {
      margin-top: 30px;
      margin-bottom: 10px;
    }
    .area-box {
      display: flex;
      .select-box {
        display: flex;
        flex: 1;
        justify-content: space-between;
        align-items: center;
        border: 1px solid #ccc;
        padding: 0 16px;
        border-radius: 4px;
        .tips {
          color: #bbb;
        }
        .van-icon {
          color: #ccc;
        }
      }
      .el-select {
        margin-right: 10px;
        flex: 1;
        &:last-child {
          margin-right: 0px;
        }
        >>> .el-input__inner {
          height: auto;
          line-height: inherit;
          font-size: inherit;
          border: 1px solid #D5DBE6;
          padding: 0px 10px;
          background: none;
          color: #333;
          font-weight: 400;
        }
        >>> .el-input__suffix {
          top: 0px;
          right: 5px;
        }
      }
    }
  }
  .answer-pc {
    .form-inner {
      margin-top: 10px;
    }
  }
  >>> .van-cascader {
    .van-cascader__options {
      height: 60vh;
    }
  }
  .action-btn {
    border-top: 1px solid #eee;
    display: flex;
    justify-content: center;
    padding: 10px 0;
    .van-button {
      width: 90%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/SelectBox/SelectBoxAnswer.vue